import { useContext } from 'react'

import { TenantContext } from './TenantContext.ts'
import type { TenantContextValue } from './tenant.ts'

export function useTenant(): TenantContextValue {
  const value = useContext(TenantContext)

  if (value === null) {
    throw new Error('useTenant must be used inside <TenantProvider>')
  }

  return value
}
